export class CalendarNavData {
  showingYear: number;
}
